const initialState = {};

const registerProductReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_REGISTER_PRODUCT_DATA':
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default registerProductReducer;
